export default __webpack_public_path__ + "static/media/locations.5a81509c.svg";